// Rejecting a counterparty asks first, and asks why (TX-US-0036). The same <dialog> every other
// confirmation uses. A refusal stays in the dialog beside the control that was refused.
//
// Legal's rejection may be final, or referred to senior management, who may override it
// (TX-US-0042, ADR-0014): either way it is Legal's rejection, with Legal's reason. A referral
// emails the approvers and waits on their answer instead of ending onboarding. Each choice says
// what it does beneath it, and nothing else in the dialog changes with the choice, so the dialog
// keeps its shape while Legal decides.

import { useState } from 'react';

import { transitionCounterparty } from '../../api.js';
import MoveDialog, { ReasonField } from '../../ui/MoveDialog.jsx';
import { moveRefusal } from './path.js';

const FINAL_HINT = 'The counterparty is marked Rejected and leaves onboarding. This cannot be undone.';

const CHOICES = [
  {
    referred: false,
    label: 'Final',
    hint: 'The counterparty is marked Rejected and leaves onboarding.',
  },
  {
    referred: true,
    label: 'Referred to senior management',
    hint: 'They are emailed and may override it; attach their written answer when it comes.',
  },
];

export default function RejectDialog({ counterparty, canRefer, onClose, onRejected }) {
  const [reason, setReason] = useState('');
  const [referred, setReferred] = useState(false);

  return (
    <MoveDialog
      refusal={moveRefusal}
      title={`Reject ${counterparty.name}?`}
      hint={canRefer ? null : FINAL_HINT}
      submitLabel="Reject counterparty"
      busyLabel="Rejecting…"
      danger
      ready={Boolean(reason.trim())}
      move={() => transitionCounterparty(
        counterparty.counterparty_id, referred ? 'OVERRIDE_REQUESTED' : 'REJECTED',
        counterparty.version, reason.trim(),
      )}
      onClose={onClose}
      onMoved={onRejected}
    >
      <ReasonField value={reason} onChange={setReason} />
      {canRefer && (
        <fieldset className="choice-set stacked">
          <legend>The rejection is</legend>
          {CHOICES.map((choice) => (
            <label key={choice.label} className="choice">
              <input type="radio" name="rejection" checked={referred === choice.referred}
                     onChange={() => setReferred(choice.referred)} />
              <span>
                {choice.label}
                <small className="choice-hint">{choice.hint}</small>
              </span>
            </label>
          ))}
        </fieldset>
      )}
    </MoveDialog>
  );
}
